
import { useState, useEffect } from "react";
import { Popup, Icon, Table } from "semantic-ui-react";
import { useHistory, useParams } from "react-router";
import GenderIcon from "../reservation/genderIcon";

export default function DetailRatePopup(props) {
  let { cruise_id } = useParams();
  let history = useHistory();
  const [totales, setTotales] = useState({ price: 0, commission_price: 0, flight_price: 0, special_discount_price: 0, charter_price: 0 });

  const handleClick = (bookingId) => {
    history.push(`/cruises/${cruise_id}/reservations/${props.reservation.id}/bookings/${bookingId}/spaces`)
  }

  useEffect(() => {
    if (props.reservation.charter && (!props.reservation.contract_rate && !props.reservation.ikarus_rate)) {
      const price = props.reservation.client_price;
      const commission_price = props.reservation.client_price * (props.reservation.agency_commission / 100);
      const flight_price = props.spaces.reduce((acum, item) => acum + (parseFloat(item.flight_price) || 0), 0);
      const special_discount_price = props.spaces.reduce((acum, item) => acum + (parseFloat(item.special_discount_price) || 0), 0);

      setTotales({
        price: price,
        commission_price: commission_price,
        flight_price: flight_price,
        special_discount_price: special_discount_price,
        charter_price: ((price - commission_price) + flight_price) - special_discount_price,
      });

    } else if (props.reservation.contract_rate || props.reservation.ikarus_rate) {
      const totales = props.spaces.reduce((acum, item) => {
        acum.price += parseFloat(item.price) || 0;
        acum.commission_price += parseFloat(item.commission_price) || 0;
        acum.flight_price += parseFloat(item.flight_price) || 0;
        acum.special_discount_price += parseFloat(item.special_discount_price) || 0;
        return acum;
      }, { price: 0, commission_price: 0, flight_price: 0, special_discount_price: 0 });

      setTotales(totales);
    }
  }, [props.spaces, props.reservation.charter, props.reservation.contract_rate, props.reservation.ikarus_rate, props.reservation.client_price, props.reservation.commission_percentage]);

  return (
    <>
      <Popup className="max-h-[400px] overflow-y-auto" trigger={<Icon name='info' color='red' size='small' circular />} flowing hoverable>
        <Table color="blue">
          <Table.Header>
            <Table.Row align="center">
              <Table.HeaderCell></Table.HeaderCell>
              <Table.HeaderCell>Cabina<br /><br /></Table.HeaderCell>
              <Table.HeaderCell>Crucero<br /><br /></Table.HeaderCell>
              <Table.HeaderCell>Comisión<br /><br /></Table.HeaderCell>
              <Table.HeaderCell>Descuento<br />Adicional</Table.HeaderCell>
              <Table.HeaderCell>Vuelo<br /><br /></Table.HeaderCell>
              <Table.HeaderCell>Total<br /><br /></Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {props.spaces.map((space) => (
              <Table.Row align="center" key={space.id} className='hover:bg-gray-300/30 cursor-pointer' onClick={() => handleClick(space.booking_id)}>
                <Table.Cell><GenderIcon gender={space.gender_name} />
                  {space.tour_leader ? <> <br /><span className="text_date_format uppercase">Tour Leader</span></> : ''}
                </Table.Cell>
                <Table.Cell><b><div style={{ color: "#1261A0", fontSize: "20px" }}>{space.cabin_name}</div></b></Table.Cell>
                <Table.Cell>$ {space.price}<br /><span className="text_date_format">{space.rate}</span></Table.Cell>
                <Table.Cell>- $ {space.commission_price}<br /><span className="text_date_format">{space.commission_percentage}%</span></Table.Cell>
                <Table.Cell>$ {space.flight_price}<br /><span className="text_date_format">{space.include_flight_ticket ? "Valor incluído en tarifa" : ""}</span></Table.Cell>
                <Table.Cell>- $ {space.special_discount_price}</Table.Cell>
                <Table.Cell align="left"><b><div>$ {space.total_price}</div></b><span className="text_date_format">Operadora: $ {space.operator_price}</span></Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>

          <Table.Footer>
            <Table.Row align="center">
              <Table.HeaderCell><b>TOTAL:</b></Table.HeaderCell>
              <Table.HeaderCell />
              <Table.HeaderCell><b><div>$ {totales.price?.toFixed(2)}</div></b></Table.HeaderCell>
              <Table.HeaderCell><b><div>$ {totales.commission_price?.toFixed(2)}</div></b></Table.HeaderCell>
              <Table.HeaderCell><b><div>$ {totales.flight_price?.toFixed(2)}</div></b></Table.HeaderCell>
              <Table.HeaderCell><b><div>$ {totales.special_discount_price?.toFixed(2)}</div></b></Table.HeaderCell>
              <Table.HeaderCell><b><div style={{ color: "#1261A0" }}>$ {totales.charter_price > 0 ? totales.charter_price?.toFixed(2) : props.client_price}</div></b><span className="text_date_format">Operadora: $ {props.operator_price}</span></Table.HeaderCell>
            </Table.Row>
          </Table.Footer>

        </Table>
      </Popup>
    </>
  );
}